"use strict";
import format from "./general";
import charDiff from "../util/char_diff";
const otherInvoiceNumber = (rule) => {
  if (rule.data.invoice_number && rule.data.other_invoice_number) {
    return charDiff.diff(
      rule.data.invoice_number,
      rule.data.other_invoice_number
    );
  }
  return rule.data.other_invoice_number || "unknown number";
};
export default {
  ruleAsPlainText: function(rule, prePependText = "", shouldIncludeDisplayTextDetails = false) {
    return String(
      this.rule(rule, prePependText, shouldIncludeDisplayTextDetails)
    ).replace(/<[^>]+>/gm, "");
  },
  rule: function(rule, prePependText = "", shouldIncludeDisplayTextDetails = false) {
    switch (rule.rule_type) {
      case "duplicate_factor_invoice":
        const fuelAdvance = rule.data.other_fuel_advance ? " Fuel Advance " : "";
        const amountAndDate = " for " + (format.currency(rule.data.other_amount) || "unknown amount") + " on " + (rule.data.other_date ? format.date(rule.data.other_date) : "unknown date");
        const identifierType = rule.data.primary_reference_type || "load_id";
        if (identifierType === "load_id") {
          return ' Duplicate invoice match: Load "' + rule.data.load_id + '" for ' + rule.data.debtor + " on Invoice: " + (rule.data.invoice_number || "unknown number") + " is similar to " + fuelAdvance + "<a href='/app/factor_invoices/" + rule.data.other_invoice_id + `' target='_blank'>Invoice:"` + (otherInvoiceNumber(rule) || "unknown number") + '"</a> ' + amountAndDate + ".";
        } else {
          return ' Duplicate invoice match: Invoice: "' + (rule.data.invoice_number || "unknown number") + '" for ' + rule.data.debtor + " is similar to " + fuelAdvance + "<a href='/app/index-document-batches/" + rule.data.other_document_batch_id + "/factor_invoices/" + rule.data.other_invoice_id + `'target='_blank'>Invoice:"` + (otherInvoiceNumber(rule) || "unknown number") + '"</a> ' + amountAndDate + ".";
        }
      case "duplicate_invoice":
        const amount = format.currency(rule.data.amount) !== void 0 ? " for " + format.currency(rule.data.amount) : " with no amount set";
        if (rule.failure_type === "missing_invoice_number") {
          return "No invoice number found.";
        }
        return 'Duplicate invoice match: Invoice "' + rule.data.invoice_number + '" similar to "' + charDiff.diff(
          rule.data.invoice_number,
          rule.data.other_invoice_number
        ) + '"' + amount + " on load <a href='/app/loads/" + rule.data.load_state_id + "/carrier_invoices/" + rule.data.other_invoice_id + "' target='_blank'>" + (rule.data.existing_load_id || rule.data.load_state_id) + "</a> on " + format.date(rule.data.date) + ".";
      case "duplicate_carrier_invoice_bol_number":
        const invoice_dupes_text = rule.data.duplicate_invoices.map(
          (invoice) => {
            return "Duplicate BOL number found for Load <a href='/app/loads/" + invoice.load_state_id + "/carrier_invoices/" + invoice.id + "' target='_blank'>#" + invoice.load_id + "</a> on invoice #" + invoice.invoice_number;
          }
        );
        const legacy_dupes_text = rule.data.duplicate_legacy_bols.map(
          (legacy_bol) => {
            return "Duplicate found in " + legacy_bol.source_system + " on BOL #" + legacy_bol.bol_number;
          }
        );
        return invoice_dupes_text.concat(legacy_dupes_text).join(", ");
      case "ltl_items_not_equal":
        let secondaryText = [];
        if (shouldIncludeDisplayTextDetails) {
          secondaryText = rule.display_text_details.map(
            (display_text_detail) => {
              if (display_text_detail.detail_type == "none") {
                return `
${prePependText}    ${display_text_detail.text}`;
              } else {
                return "";
              }
            }
          );
        }
        return rule.display_text + secondaryText.join("");
      default:
        return rule.display_text;
    }
  }
};
